import type { WallCard } from '@walls/store';

export function getCardText(card: WallCard) {
  const text = card.title?.trim() || card.content?.trim() || '';

  return stripHtml(text);
}

export function getCardShape(card: WallCard) {
  return card.shape?.trim().toLowerCase() || 'card';
}

export function getCardType(card: WallCard) {
  return card.type?.trim().toLowerCase() || 'text';
}

export function getCardDimensions(card: WallCard, fallbackWidth = 200, fallbackHeight?: number) {
  return {
    width: card.width ?? fallbackWidth,
    height: card.height ?? fallbackHeight,
  };
}

function stripHtml(value: string) {
  return value.replace(/<[^>]*>/g, '').trim();
}
